import { render, staticRenderFns } from "./rightimfo.vue?vue&type=template&id=9ee5d742&scoped=true&"
import script from "./rightimfo.vue?vue&type=script&lang=js&"
export * from "./rightimfo.vue?vue&type=script&lang=js&"
import style0 from "./rightimfo.vue?vue&type=style&index=0&id=9ee5d742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee5d742",
  null
  
)

export default component.exports